import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=a4ef0d72&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"
import style0 from "./Country.vue?vue&type=style&index=0&id=a4ef0d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ef0d72",
  null
  
)

export default component.exports